import { darkModeColors, useLocalThemeContext } from '@elements-financial/elements';
import { Skeleton } from '@mui/material';

export function ConversationPageFooterSkeleton() {
  const { colorPalette } = useLocalThemeContext();

  return (
    <div className="h-max min-h-[120px] w-full bg-darkMode-gray-dark">
      <Skeleton
        width={209}
        height={13}
        variant="rounded"
        className="mt-[27px] ml-7"
        sx={{
          borderRadius: '5px',
          backgroundColor: `${darkModeColors.gray.light}4D`,
        }}
      />
      <div className="flex h-[78px] items-center justify-between pl-8 pr-11">
        <Skeleton
          width={40}
          height={40}
          variant="circular"
          className="mb-6 mt-4"
          sx={{
            backgroundColor: `${colorPalette?.[600]}99`,
          }}
        />
        <Skeleton
          width={111}
          height={40}
          variant="rounded"
          sx={{
            borderRadius: '20px',
            backgroundColor: `${darkModeColors.gray.medium}80`,
          }}
        />
      </div>
    </div>
  );
}
